import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./components/home/landing-page-banco-micrositio/landing-page-banco-micrositio.module').then(m => m.LandingPageBancoMicrositioModule)
  },
  {
    path: '**', pathMatch: 'full',
    loadChildren: () => import('./components/home/not-found/not-found.module').then(m => m.NotFoundModule)
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
